<template>
  <v-container
    fluid
    cols="12"
    class="d-flex grey lighten-2 trade-detail"
  >
    <!-- BUYER DETAILS START -->
    <v-card class="ma-2 pa-6">
      <v-card-title class="toolbar success white--text subheading">
        <span>Buyer: </span>
        <UserChip
          :id="buyer(item).user_id"
        />
      </v-card-title>

      <v-card-text>
        <v-layout
          wrap
          class="pa-0 "
        >
          <v-flex
            v-for="field in cleanFields(buyer(item))"
            :key="field"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                >
                  <v-text-field
                    :label="formatFieldName(field, buyer(item))"
                    :value="formatValue(buyer(item)[field], field)"
                    readonly
                    class="body-1"
                    :class="field"
                  />
                </span>
              </template>
              <span>
                field: {{ field }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- BUYER DETAILS END -->

    <!-- SELLER DETAILS START -->
    <v-card class="ma-2 pa-6">
      <v-card-title class="toolbar primary white--text subheading">
        <span>Seller: </span>

        <UserChip
          :id="seller(item).user_id"
        />
      </v-card-title>


      <v-card-text>
        <v-layout
          wrap
          class="pa-0 "
        >
          <v-flex
            v-for="field in cleanFields(seller(item))"
            :key="field"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="formatFieldName(field, seller(item))"
                    :value="formatValue(seller(item)[field], field)"
                    readonly
                    class="body-1"
                    :class="field"
                  />
                </span>
              </template>
              <span>
                field: {{ field }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- SELLER DETAILS END -->

    <!-- ASSET DETAILS START -->
    <v-card class="ma-2 pa-6">
      <v-card-title class="toolbar secondary white--text subheading">
        <v-icon color="white">
          library_books
        </v-icon>
        <span> Asset details</span>
      </v-card-title>
      <v-card-text>
        <v-layout
          wrap
          class="pa-0 "
        >
          <v-flex
            v-for="field in cleanFields(offer(item).asset)"
            :key="field"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="formatFieldName(field, item)"
                    :value="formatValue(offer(item).asset[field], field)"
                    readonly
                    class="body-1"
                    :class="field"
                  />
                </span>
              </template>
              <span>
                field: {{ field }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- ASSET DETAILS END -->
  </v-container>
</template>

<script>
import _ from 'lodash';
import TradeStatesEnum from '@/enum/trades/TradeStates';
import AssetProvidersEnum from '@/enum/trades/AssetProviders';
import CustodyTypesEnum from '@/enum/trades/CustodyTypes';
import UserChip from '@/components/shared/user/UserChip';

export default {
  name: 'TradeDetail',
  components: {
    UserChip,
  },
  props: {
    item: {
      type: Object,
      default: () => [],
    },
    tradesPagination: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredItems() {
      return this.trades.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
    filteredResults() {
      if (this.hasResultFilters) {
        return this.filteredItems.filter((item) => {
          let hasProvider = false;
          let hasAssetType = false;
          let hasSearch = false;

          const { providerType, assetType, searchResults } = this.resultFilters;

          if (providerType) {
            hasProvider = this.offer(item).asset.provider === providerType;
          }
          if (assetType) {
            hasAssetType = this.offer(item).asset.type === assetType;
          }

          if (searchResults) {
            hasSearch = JSON.stringify(item)
              .toLowerCase()
              .includes(searchResults.toLowerCase());
          }

          return (!!hasProvider || !!hasAssetType || !!hasSearch) || false;
        });
      }

      return this.filteredItems;
    },

    tradeStates() {
      return Object.keys(TradeStatesEnum).map(key => ({
        text: this.formatFieldName(TradeStatesEnum[key]),
        value: TradeStatesEnum[key],
      }));
    },
    providers() {
      return Object.keys(AssetProvidersEnum).map(key => ({
        text: this.formatFieldName(AssetProvidersEnum[key]),
        value: AssetProvidersEnum[key],

      }));
    },
    assetTypes() {
      return Object.keys(CustodyTypesEnum).map(key => ({
        text: this.formatFieldName(CustodyTypesEnum[key]),
        value: CustodyTypesEnum[key],
      }));
    },
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    offer(item) {
      if (item.buy_offer_id) {
        return item.buy_offer;
      }
      if (item.sell_offer_id) {
        return item.sell_offer;
      }

      return item;
    },
    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },

    seller(item) {
      return item.sell_offer_id
        ? item.sell_offer
        : item;
    },
    buyer(item) {
      return item.buy_offer_id
        ? item.buy_offer
        : item;
    },

    /**
     * removes keys from object if value is falsy or typeof object
     */
    cleanFields(data) {
      return Object.keys(data)
        .filter(field => !!data[field] && typeof data[field] !== 'object');
    },

    formatFieldName(str, item) {
      const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
      const sentence = _.startCase(camelCaseSentence);

      if (item) {
        if (str === 'security_wallet' && this.offer(item).asset.provider === 'baaderbank') {
          return `${_.capitalize(sentence)} / Baader Bank account`;
        }
      }

      return _.capitalize(sentence);
    },

    formatValue(value, key) {
      if (key === 'total' || key === 'unit_price') {
        return this.centsToEuros(value);
      }
      if (key.includes('_at')) {
        return this.formatDate(value);
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.trade-detail{

}
</style>



// WEBPACK FOOTER //
// src/components/trades/shared/TradeDetail.vue